import gql from "graphql-tag";

export default {
  forms: gql`
    query {
      forms {
        id
        formName
        formDescription
        formStatus
        formFields {
          id
          name
          code
          description
          type
          options {
            canAddValueManual
            canChoiceMultiple
            choices
            defaultValue
            friendlyFormat
            includeTime
            isRequireValue
            setMax
            setMin
          }
        }
        author {
          id
          username
        }
        createdAt
        updatedAt
      }
    }
  `
};
